import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Container } from "react-bootstrap";
import Input from "../../UI/Input";
import Checkbox from "../../UI/CheckBox";
import SingleInput from "../../UI/SingleInput";
import DragableMap from "../../UI/DragableMap";
import { useDispatch, useSelector } from "react-redux";
import {
  editTaskCustomer,
  getCustomerList,
} from "../../../store/actions/taskManager.action";
import { getAddress } from "../../../services/localStorageService";
import { ShowNotification } from "../../../services/Notifications";
import TaskManagerRequest from "../../../services/TaskManagerRequest";
import { dubaiCoordinates } from "../../../configs/common";

const EditCustomerModal = (props) => {
  const dispatch = useDispatch();
  const groups = useSelector((state) => state.taskReducer.customerGroups);
  const poiGroups = useSelector((state) => state.taskReducer.poi);
  const [position, setPosition] = useState(dubaiCoordinates);
  const [address, setAddress] = useState("");
  const [search, setSearch] = useState("");

  const [addressByPoi, setAddressByPoi] = useState(false);
  const checkedChange = (event) => {
    setAddressByPoi(event.target.checked);
  };

  const onSetPosition = (data) => {
    setAddressByPoi(false);
    setPosition(data.position);
    setAddress(data.address);
  };

  const onPoiAddressSelect = async (event) => {
    const addresData = poiGroups.find(
      (item) => item.gz_id == event.target.value
    );
    if (addresData) {
      setAddress(addresData.gz_name);
      setPosition({
        lat: parseFloat(addresData.gz_latitude),
        lng: parseFloat(addresData.gz_longitude),
      });
    }
  };

  useEffect(() => {
    if (props.show == true && props.customer) {
      setAddress(props.customer.address);
      setPosition({
        lat: parseFloat(props.customer.location.latitude),
        lng: parseFloat(props.customer.location.longitude),
      });
    }
  }, [props.show]);

  const handleSubmit = async (event) => {
    const formData = new FormData(event.target);
    event.preventDefault();

    let data = { ...props.customer };

    for (let [key, value] of formData.entries()) {
      if (value !== "") data[key] = value;
    }

    //Addredd By POI
    if (addressByPoi) data["customer_address"] = data["POIaddress"];

    //Add Latitude and Longtitude
    data["location"] = { latitude: position.lat, longitude: position.lng };
    data["address"] = address;

    // API call here
    try {
      const response = await TaskManagerRequest(`/edit/customer`, data);
      await dispatch(getCustomerList({}));
      ShowNotification("success", "Customer edited successfully");
      props.toggleModal();
    } catch (error) {
      ShowNotification("error", error);
    }
  };

  const onSearchPosition = () => {
    var parts = search.split(",");
    if (parts.length >= 2) {
      setPosition({
        lat: parseFloat(parts[0].trim()),
        lng: parseFloat(parts[1].trim()),
      });
    }
  };

  return (
    <>
      <Modal
        show={props.show}
        dialogClassName="modal-30w"
        onHide={props.toggleModal}
        aria-labelledby="EditCustomerModal"
      >
        <Modal.Header closeButton>Edit Customer</Modal.Header>
        <form onSubmit={handleSubmit}>
          <Modal.Body className="show-grid">
            <Container>
              <Input
                name="name"
                label="Name"
                value={props.customer && props.customer.name}
              />

              <select
                name="groupName"
                defaultValue={
                  props.customer && props.customer.groupName
                    ? props.customer.groupName._id
                    : ""
                }
                className="font-12 outline-none border-theme r-3 w-100 p-2 mt-2"
              >
                <option value="">Select Group</option>
                {groups.map((group, i) => (
                  <option key={i} value={group._id}>
                    {group.name}
                  </option>
                ))}
              </select>

              <div className="d-flex">
                <Checkbox
                  className="chk-bordered"
                  id={1}
                  checked={addressByPoi}
                  onChange={(event) => checkedChange(event)}
                />
                <span className="text-light-secondary font-12 mt-2 ml-2">
                  Address by POI
                </span>
              </div>

              {!addressByPoi && (
                <SingleInput
                  name="address"
                  placeholder="Address"
                  value={address}
                  className="mt-2"
                />
              )}

              {addressByPoi && (
                <select
                  name="POIaddress"
                  onChange={onPoiAddressSelect}
                  className="font-12 outline-none border-theme r-3 w-100 p-2 mt-2"
                >
                  <option value="">Select POI</option>
                  {poiGroups.map((group, i) => (
                    <option key={i} value={group.gz_id}>
                      {group.gz_name}
                    </option>
                  ))}
                </select>
              )}

              <div className="row m-0 mt-2">
                <div className="col-md-9 p-0">
                  <SingleInput
                    placeholder="25.2048, 55.2708"
                    value={search}
                    onChange={(event) => setSearch(event.target.value)}
                  />
                </div>
                <div className="col-md-3 p-0 text-right ">
                  <button
                    type="button"
                    className="btn btn-search mb-0 pl-2 pr-2 ml-2"
                    onClick={onSearchPosition}
                  >
                    <i className="fa fa-search font-12"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-theme mb-0 pl-2 pr-2 ml-2"
                    onClick={() => setSearch("")}
                  >
                    <i className="fa fa-refresh font-12"></i>
                  </button>
                </div>
              </div>

              <div
                style={{ height: "200px", width: "100%" }}
                className="hide-control mt-2"
              >
                {addressByPoi && (
                  <DragableMap
                    onDragChange={onSetPosition}
                    position={position}
                    allowUpdateOnChange={true}
                  />
                )}
                {!addressByPoi && (
                  <DragableMap
                    onDragChange={onSetPosition}
                    position={position}
                    allowUpdateOnChange={true}
                  />
                )}
              </div>
              <SingleInput
                name="contactName"
                value={props.customer && props.customer.contactName}
                placeholder="Contact Name"
                className="mt-2"
                defaultValue={props.customer.contactName || ""}
              />
              <SingleInput
                name="phoneNumber"
                value={props.customer && props.customer.phoneNumber}
                placeholder="Contact Number"
                className="mt-2"
                defaultValue={props.customer.phoneNumber}
              />
              <SingleInput
                name="email"
                value={props.customer && props.customer.email}
                placeholder="Email"
                defaultValue={props.customer.email}
                className="mt-2"
              />
              <SingleInput
                name="description"
                value={props.customer && props.customer.description}
                placeholder="Note"
                className="mt-2"
                defaultValue={props.customer.description}
              />
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              style={{ fontSize: "12px" }}
              className="btn btn-small"
              onClick={props.toggleModal}
            >
              Cancel
            </button>
            <button
              style={{
                fontSize: "12px",
                backgroundColor: "#007bff",
                color: "#ffffff",
              }}
              className="btn btn-small"
            >
              Update
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default EditCustomerModal;

// import React, { useState, useEffect } from 'react'
// import Modal from 'react-bootstrap/Modal'
// import { Container } from "react-bootstrap";
// import Input from '../../UI/Input';
// import Checkbox from '../../UI/CheckBox'
// import SingleInput from '../../UI/SingleInput'
// import DragableMap from '../../UI/DragableMap';
// import { useDispatch, useSelector } from 'react-redux';
// import { editTaskCustomer, getCustomerList } from '../../../store/actions/taskManager.action';
// import { getAddress } from '../../../services/localStorageService';
// import { ShowNotification } from '../../../services/Notifications';

// const EditCustomerModal = (props) => {

//     const dispatch = useDispatch();
//     const groups = useSelector(state => state.taskReducer.customerGroups)
//     const poiGroups = useSelector(state => state.taskReducer.poi)
//     const [position, setPosition] = useState(dubaiCoordinates)
//     const [address, setAddress] = useState('')
//     const [search, setSearch] = useState('')

//     const [addressByPoi, setAddressByPoi] = useState(false)
//     const checkedChange = (event) => {
//         setAddressByPoi(event.target.checked)
//     }

//     const onSetPosition = (data) => {
//         setAddressByPoi(false)
//         setPosition(data.position)
//         setAddress(data.address)
//     }

//     const onPoiAddressSelect = async (event) => {
//         const addresData = poiGroups.find((item) => item.gz_id == event.target.value)
//         if (addresData) {
//             setAddress(addresData.gz_name)
//             setPosition({ lat: parseFloat(addresData.gz_latitude), lng: parseFloat(addresData.gz_longitude) })
//         }
//     }

//     useEffect(() => {
//         if (props.show == true && props.customer) {
//             setAddress(props.customer.customer_address)
//             setPosition({ lat: parseFloat(props.customer.customer_lattitude), lng: parseFloat(props.customer.customer_longitude) })
//         }
//     }, [props.show])

//     const handleSubmit = async (event) => {

//         const formData = new FormData(event.target);
//         event.preventDefault();

//         let data = { ...props.customer }

//         for (let [key, value] of formData.entries()) {
//             if(value !== '') data[key] = value;
//         }

//         //Addredd By POI
//         if (addressByPoi) data['customer_address'] = data['POIaddress']

//         //Add Latitude and Longtitude
//         data['customer_lattitude'] = position.lat
//         data['customer_longitude'] = position.lng
//         data['customer_address'] = address

//         // API call here
//         await dispatch(editTaskCustomer(data))
//         ShowNotification('success', 'Customer Edited Successfully')
//         await dispatch(getCustomerList({}))

//         props.toggleModal();

//     }

//     const onSearchPosition = () => {
//         var parts = search.split(',')
//         if (parts.length >= 2) {
//             setPosition({ lat: parseFloat(parts[0].trim()), lng: parseFloat(parts[1].trim()) })
//         }
//     }

//     return (
//         <>
//             <Modal
//                 show={props.show}
//                 dialogClassName="modal-30w"
//                 onHide={props.toggleModal}
//                 aria-labelledby="EditCustomerModal"
//             >
//                 <Modal.Header closeButton >
//                     Edit Customer
//                 </Modal.Header>
//                 <form onSubmit={handleSubmit} >
//                     <Modal.Body className="show-grid">
//                         <Container>

//                             <Input name="customer_name" label="Name" value={props.customer && props.customer.customer_name} />

//                             <select name="customer_group_id" value={props.customer && props.customer.customer_group_id} className="font-12 outline-none border-theme r-3 w-100 p-2 mt-2">
//                                 <option value="" >Select Group</option>
//                                 {
//                                     groups.map((group, i) => <option key={i} value={group.customer_group_id}>{group.customer_group_name}</option>)
//                                 }
//                             </select>

//                             <div className="d-flex">
//                                 <Checkbox className="chk-bordered" id={1} checked={addressByPoi} onChange={(event) => checkedChange(event)} />
//                                 <span className="text-light-secondary font-12 mt-2 ml-2">Address by POI</span>
//                             </div>

//                             {!addressByPoi &&
//                                 <SingleInput name="customer_address" placeholder="Address" value={address} className="mt-2" />
//                             }

//                             {addressByPoi &&
//                                 <select name="POIaddress" onChange={onPoiAddressSelect} className="font-12 outline-none border-theme r-3 w-100 p-2 mt-2">
//                                     <option value="" >Select POI</option>
//                                     {
//                                         poiGroups.map((group, i) => <option key={i} value={group.gz_id}>{group.gz_name}</option>)
//                                     }
//                                 </select>
//                             }

//                             <div className="row m-0 mt-2">
//                                 <div className="col-md-9 p-0">
//                                     <SingleInput placeholder="25.2048, 55.2708" value={search} onChange={(event) => setSearch(event.target.value)} />
//                                 </div>
//                                 <div className="col-md-3 p-0 text-right ">
//                                     <button type="button" className="btn btn-search mb-0 pl-2 pr-2 ml-2" onClick={onSearchPosition}><i className="fa fa-search font-12"></i></button>
//                                     <button type="button" className="btn btn-theme mb-0 pl-2 pr-2 ml-2" onClick={() => setSearch('')}><i className="fa fa-refresh font-12"></i></button>
//                                 </div>
//                             </div>

//                             <div style={{ height: '200px', width: '100%' }} className="hide-control mt-2">
//                                 {addressByPoi && <DragableMap onDragChange={onSetPosition} position={position} />}
//                                 {!addressByPoi && <DragableMap onDragChange={onSetPosition} position={position} />}
//                             </div>

//                             <SingleInput name="customer_contact" value={props.customer && props.customer.customer_contact} placeholder="Contact" className="mt-2" defaultValue={props.customer.customer_contact} />
//                             <SingleInput name="customer_email" value={props.customer && props.customer.customer_email} placeholder="Email" defaultValue={props.customer.customer_email} className="mt-2" />
//                             <SingleInput name="customer_description" value={props.customer && props.customer.customer_description} placeholder="Note" className="mt-2" defaultValue={props.customer.customer_description} />

//                         </Container>
//                     </Modal.Body>
//                     <Modal.Footer>
//                         <button type="button" style={{ fontSize: '12px' }} className="btn btn-small" onClick={props.toggleModal}>Cancel</button>
//                         <button style={{ fontSize: '12px', backgroundColor: '#007bff', color: '#ffffff' }} className="btn btn-small" >Update</button>
//                     </Modal.Footer>
//                 </form>
//             </Modal>
//         </>
//     )
// }

// export default EditCustomerModal
